import './ReportsDescription.css';
import { t } from 'i18next';
import React from 'react';
import { connect } from 'react-redux';
import { formatDesc } from '../../../helpers/formatter';
import Tooltip from '../../toolTip/tooltip';

const ReportsDescription = ({
  descriptionObj, id, isMeteringPage = false, title, width,
}) => (
  <div className={isMeteringPage ? 'flex-wrapper' : 'ReportDescription'}>
    <h2>{title}</h2>
    { descriptionObj && descriptionObj.description
     && (
       <div className="Reports-section">
         { ! isMeteringPage && (
           <div className="textContainer">
             <div className={`DescriptionText ${descriptionObj.isExpanded ? 'expand' : ''}`}
               style={{
                 width,
               }}
             >
               { ! descriptionObj.isExpanded
                 ? formatDesc(descriptionObj.description) : formatDesc(descriptionObj.expanded_desc) }
               <a onClick={() => descriptionObj.toggle()}>
                 { ! descriptionObj.isExpanded ? t('reportsDescription.seeMore') : t('reportsDescription.seeLess')}
               </a>
             </div>
           </div>
         )
         }
         { isMeteringPage && (<Tooltip description={descriptionObj.expanded_desc} id={id} />)}
       </div>
     )
    }
  </div>
);


export default connect()(ReportsDescription);
